import {motion} from "framer-motion";
import React from "react";
import {Button} from "../components/button";
import {useMedia} from "../hooks/useMedia";
import {cn, spring} from "../lib/utils";
import {useCTAContent} from "./useCTAContent";

function FloatingActionBar({
  onAction,
  cta,
}: {
  onAction: () => void;
  cta: ReturnType<typeof useCTAContent>;
}) {
  const isMobile = useMedia("(max-width: 768px)", true);

  return (
    <div
      className={cn([
        "fixed flex gap-2 justify-between bottom-0 left-0 right-0 z-20 pointer-events-none",
        "md:sticky md:bottom-[3vh]",
      ])}
    >
      <motion.div
        initial={{
          opacity: 0,
          y: !isMobile ? "100%" : 0,
          scale: !isMobile ? 1 : 0.5,
        }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        transition={{
          delay: 1,
          ...(!isMobile ? spring.smooth : spring.bouncy),
        }}
        className={cn([
          "flex gap-3 justify-between mx-auto bg-white p-3 border-t border-gray-200 shadow-[0_-10px_30px_0_rgb(0_0_0_/_0.05)] pointer-events-auto",
          "md:rounded-full md:justify-between md:p-2 md:shadow-xl md:border md:border-gray-100 max-sm:w-full",
        ])}
      >
        <div className="flex flex-col items-start md:pl-6 md:justify-center">
          {cta.headline}
          <small className="text-base leading-3 first-letter:uppercase whitespace-nowrap">
            {cta.body}
          </small>
        </div>
        <Button
          onClick={onAction}
          className="max-sm:px-6 max-sm:w-full md:px-8 !rounded-full"
        >
          {cta.buttonLabel}
        </Button>
      </motion.div>
    </div>
  );
}

export {FloatingActionBar};
